<template>
  <v-app>
    <v-main>
      <v-progress-linear v-if="loader" indeterminate height="5" color="primary" absolute></v-progress-linear>
      <v-container class="pa-0" fluid>
        <dr-layout-placeholder
          :readonly="readonly"
          @modelChanged="onModelChanged"
          :model="{ $ID: modelId, Name: 'EmptyLayout' }"
        ></dr-layout-placeholder>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  export default {
    name: 'EmptyLayout',
    props: {
      readonly: {
        type: Boolean
      }
    },
    computed: {
      modelId() {
        return `${this.$route.name}empty-layout`
      },

      loader() {
        return this.$store.getters.getProcessing
      }
    },
    methods: {
      onModelChanged(value) {
        this.$emit('modelChanged', value)
      }
    }
  }
</script>
